// assets
import { ToolOutlined, UnorderedListOutlined, SettingOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

// icons
const icons = {
  ToolOutlined,
  UnorderedListOutlined,
  SettingOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const config = {
  id: 'config_parent',
  title: '',
  type: 'group',
  children: [
    {
      id: 'config',
      title: <FormattedMessage id="config" />,
      type: 'collapse',
      icon: icons.SettingOutlined,
      children: [
        {
          id: 'brandCompanies',
          title: <FormattedMessage id="menu_items.brandCompanies" />,
          url: '/config/brand-companies',
          type: 'item'
        },
        {
          id: 'brands',
          title: <FormattedMessage id="menu_items.brands" />,
          url: '/config/brands',
          type: 'item'
        },
        {
          id: 'users',
          title: <FormattedMessage id="menu_items.users" />,
          url: '/config/users',
          type: 'item'
        }
      ]
    }
  ]
};

export default config;
